import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import HotCommentSection from "./components/HotCommentSection";
import DebateSection from "./components/DebateSection";
import CategorySection from "./components/CategorySection";
import ArticleSection from "./components/ArticleSection";
import SubscribeSection from "./components/SubscribeSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <RankingSection />
      <HotCommentSection />
      <DebateSection />
      <CategorySection />
      <ArticleSection />
      <SubscribeSection />
      <FaqSection />
      <AboutSection />
      <Footer />
      <BackToTop />
    </main>
  );
}